import React from 'react';
import { Helmet } from 'react-helmet-async';
import Contact from '../components/Contact';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://wayug.com/' },
    { '@type': 'ListItem', position: 2, name: 'Contact', item: 'https://wayug.com/contact' },
  ],
};

const ContactPage = () => {
  return (
    <div className="page-content subpage-content">
      <Helmet>
        <title>Contact Wayug Infotech — Get a Free IT Assessment Today</title>
        <meta
          name="description"
          content="Talk to our enterprise IT experts. Reach us via WhatsApp, email or phone for cloud, cybersecurity and software development consultations. Free IT assessment available."
        />
        <link rel="canonical" href="https://wayug.com/contact" />
        <meta property="og:title" content="Contact Wayug Infotech — Get a Free IT Assessment Today" />
        <meta
          property="og:description"
          content="Connect with Wayug Infotech's enterprise IT team. WhatsApp, email, or phone — we respond within 4 hours."
        />
        <meta property="og:url" content="https://wayug.com/contact" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      </Helmet>
      <Contact />
    </div>
  );
};

export default ContactPage;
